import { Navigate, Outlet } from "react-router-dom";
import { PageLoadingState } from "../components/layout/PageLoadingState";
import { useAuth } from "../data/providers/AuthProvider";

const PrivateRoute = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return <PageLoadingState label="Verificando tu sesión" fullPage />;
  }

  return user ? <Outlet /> : <Navigate to="/" />;
};

export default PrivateRoute;
